import { api } from '../../../api';
import { BooksResponse, BookType } from './types';

const BOOKS_TAG = 'Books';
const MY_BOOKS_TAG = 'MyBooks';
const MY_DRAFT_BOOKS_TAG = 'MyDraftBooks';
const BOOK_DETAILS_TAG = 'BookDetails';

export const booksApi = api
  .enhanceEndpoints({
    addTagTypes: [BOOKS_TAG, MY_BOOKS_TAG, MY_DRAFT_BOOKS_TAG, BOOK_DETAILS_TAG]
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getBooks: build.query<BooksResponse, { page?: number }>({
        query: ({ page }) => ({
          method: 'GET',
          url: 'books/',
          params: {
            offset: page
          }
        }),
        providesTags: [BOOKS_TAG]
      }),
      getMyBooks: build.query<BooksResponse, void>({
        query: () => ({
          method: 'GET',
          url: 'books/my_books/'
        }),
        providesTags: [MY_BOOKS_TAG]
      }),
      getDraftBooks: build.query<BooksResponse, void>({
        query: () => ({
          method: 'GET',
          url: 'books/my_books/draft/'
        }),
        providesTags: [MY_DRAFT_BOOKS_TAG]
      }),
      deleteBook: build.mutation<BookType, { bookId: string }>({
        query: ({ bookId }) => ({
          method: 'DELETE',
          url: `books/${bookId}`
        }),
        invalidatesTags: [MY_DRAFT_BOOKS_TAG, MY_BOOKS_TAG]
      }),
      updateBook: build.mutation<BookType, { bookId: string; formData: FormData }>({
        query: ({ bookId, formData }) => ({
          method: 'PATCH',
          url: `books/${bookId}`,
          body: formData
        }),
        invalidatesTags: (results) => [
          MY_DRAFT_BOOKS_TAG,
          MY_BOOKS_TAG,
          { type: BOOK_DETAILS_TAG, id: results?.id }
        ]
      }),
      updateBookStatus: build.mutation<BookType, { bookId: string; isDraft: boolean }>({
        query: ({ bookId, isDraft }) => ({
          method: 'PATCH',
          url: `books/${bookId}`,
          body: { is_draft: isDraft }
        }),
        invalidatesTags: [MY_DRAFT_BOOKS_TAG, MY_BOOKS_TAG]
      }),
      getBookDetails: build.query<BookType, { bookId: string }>({
        query: ({ bookId }) => ({
          method: 'GET',
          url: `books/${bookId}`
        }),
        providesTags: (args) => [{ type: BOOK_DETAILS_TAG, id: args?.id }]
      }),
      addBook: build.mutation<BookType, { formData: FormData }>({
        query: ({ formData }) => ({
          method: 'POST',
          url: 'books/my_books/',
          body: formData
        }),
        invalidatesTags: [MY_DRAFT_BOOKS_TAG, MY_BOOKS_TAG]
      })
    })
  });

export const {
  useGetBooksQuery,
  useGetBookDetailsQuery,
  useGetMyBooksQuery,
  useAddBookMutation,
  useDeleteBookMutation,
  useUpdateBookMutation,
  useGetDraftBooksQuery,
  useUpdateBookStatusMutation
} = booksApi;
